module.exports = __webpack_public_path__ + "static/media/quantum2.994e1f8b.png";